<template>
  <el-container class="player-view-inscriptions app-content-page">
    <el-row
      class="player-view-inscriptions__container"
      justify="center"
      v-loading="loading"
    >
      <el-col
        v-for="({ title, description, statusLayout, linkLayout }, i) in inscriptions"
        :key="`player-view-inscriptions__col--${i}`"
        :lg="8" :md="12" :sm="24"
      >
        <el-card 
          class="player-view-inscriptions__container__card"
          body-style="padding: 0;"
        >

          <div class="player-view-inscriptions__container__card__body">
            <!-- Title -->
            <div
              class="player-view-inscriptions__container__card__body__title"
            >
              <span>{{ title }}</span>
            </div>

            <!-- Description -->
            <div
              class="player-view-inscriptions__container__card__body__description"
            >
              <span>{{ description }}</span>
            </div>
            
            <!-- Status -->
            <div
              v-if="statusLayout"
              :style="statusLayout.style"
              class="player-view-inscriptions__container__card__body__status"
            >
              <span
                :style="{ color: statusLayout.iconColor }"
                class="player-view-inscriptions__container__card__body__status__icon"
              >
                <i class="icon-radio-button-fill" 
                   :style="getTagStyle('status', statusLayout.contentText)"
                />
              </span>

              <span
                class="player-view-inscriptions__container__card__body__status__text"
              >{{ statusLayout.contentText }}</span>
            </div>

            <!-- Link -->
            <div
              v-if="linkLayout"
              class="player-view-inscriptions__container__card__body__link"
            >
              <router-link :to="linkLayout.linkTo">
                <span>{{ linkLayout.contentText }}</span>
              </router-link>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PlayerViewToolbar from '@modules/player/components/player-view-toolbar.vue';
import { PlayerModel } from '@modules/player/player-model';
import TagsFactory from '@shared/factories/tags-factory';

export default {
  name: 'app-player-view-inscriptions',

  props: {
    id: {
      type: String,
      required: true
    },
    subpropertyId: {
      type: String,
      required: true
    }
  },

  components: {
    [PlayerViewToolbar.name]: PlayerViewToolbar,
  },

  data() {
    return {
      
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      inscriptions: 'player/viewInscriptions/inscriptions',
      loading: 'player/viewInscriptions/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      const { dateFormat, timeFormat} = this;
      return new PlayerModel({
        dateFormat,
        timeFormat
      }).fields();
    },
  },

  async created() {
    await this.doLoadInscriptions({id: this.id, subpropertyId: this.subpropertyId});
  },

  methods: {
    ...mapActions({
      doLoadInscriptions: 'player/viewInscriptions/doLoadInscriptions',
    }),

    presenter(record, fieldName) {
      const { dateFormat, timeFormat } = this;
      return new PlayerModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },


    getTagStyle(keyEnum, valueEnum) {
      const style = new TagsFactory({
        entityName: 'inscription',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
      return style;
    },
  },
};
</script>

<style lang="scss">
.player-view-inscriptions {

  &__container {
    width: 100%;
    padding: 30px 30px 22px 40px;

    &__card {
      border: 0;
      border-radius: 0;
      box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
      margin: 12.5px;
      padding:  24px 16px 17px 32px ;
      height: 50%;
      align-items: center;

      &__body {
        display: grid;
        grid-template-inscriptions: auto auto auto;
        grid-template-columns: auto auto;
        grid-template-areas:  'title title'
                              'description description'
                              'status link';
        align-items: center;
        grid-gap: 8px;

        &__title {
          grid-area: title;
          font-size: 14px;
          max-width: 246px;
          color: #404040;
          line-height: 1.29;
        }
      
        &__description {
          grid-area: description;
          font-size: 14px;
          max-width: 246px;
          color: #c5c5c5;
          margin-bottom: 10px;
        }
      
        &__status {
          grid-area: status;
          display: grid;
          grid-template-inscriptions: 1fr;
          grid-template-columns: 32px auto;
          grid-template-areas: 'icon_status text_status';

          border-radius: 7.5px;
          box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
          padding: 8px;
          padding-right: 30px;
          justify-self: self-start;
          align-items: center;

          &__icon {
            grid-area: icon_status;
          }

          &__text {
            grid-area: text_status;
            font-size: 12px;
            color: #606266;
            text-align: center;
          
          }
        }
        
        &__link {
          grid-area: link;
          color: #2acccc;
          font-size–: 12px;
          font-weight: 500;
          justify-self: flex-end;
        }
      }
    }
  }
}
</style>
